import {connect} from 'react-redux';
import AppMain from '../../app/main/AppMain.js';
import AppMainPageAction from '../actions/AppMainPageAction.js';

const mapStateToProps = state => {
    return {
        appMainPage: state.AppMainPageReducer.appMainPage
    };
};

const mapDispatchToProps = dispatch => {
    return {
      appMainPageCreate: (data) => {
            dispatch(AppMainPageAction(data));
      },
    };
};

const AppMainContainers = connect(
   mapStateToProps,
   mapDispatchToProps
)(AppMain);

export default AppMainContainers;

